import React from "react";
import { Link } from "react-router-dom";

export interface PaziaTab {
  name: string;
  active: boolean;
  link?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const PaziaTabs = ({
  tabs,
  center,
  className = "",
}: {
  className?: string;
  center?: boolean;
  tabs: PaziaTab[];
}): JSX.Element => {
  return (
    <div className={`w-full ${className}`}>
      <div className={`relative flex ${center ? "justify-center" : ""}`}>
        <div className="no-scrollbar relative flex flex-nowrap gap-2 overflow-x-scroll border-b border-slate-200 dark:border-slate-700">
          {tabs.map((tab) => (
            <SingleTab key={tab.name} tab={tab} />
          ))}
        </div>
      </div>
    </div>
  );
};

const SingleTab = ({ tab }: { tab: PaziaTab }) => {
  const onClickHandler = (tab: PaziaTab) => {
    if (tab.active || tab.disabled) return;
    if (tab.onClick) tab.onClick();
  };

  const activeClasses =
    "bg-white dark:bg-slate-800 text-primary-600 dark:text-primary-400 border border-b-0 border-slate-200 dark:border-slate-700 rounded-t-lg font-semibold shadow-sm";
  const inactiveClasses =
    "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800/50 border border-transparent rounded-t-lg";
  const inactiveDisabledClasses =
    "text-slate-400 dark:text-slate-600 bg-slate-100 dark:bg-slate-800/30 border border-transparent rounded-t-lg cursor-not-allowed opacity-60";

  const baseClasses = "relative px-4 py-2.5 text-sm font-medium transition-all duration-200 whitespace-nowrap -mb-px";
  const cursorClass = tab.active || tab.disabled ? "" : "cursor-pointer";

  const getTabClasses = () => {
    if (tab.active) return activeClasses;
    if (tab.disabled) return inactiveDisabledClasses;
    return inactiveClasses;
  };

  return (
    <>
      {tab.link ? (
        <Link
          key={tab.name}
          to={tab.link}
          className={`${baseClasses} ${cursorClass} ${getTabClasses()}`}
          onClick={(e) => {
            if (tab.disabled) e.preventDefault();
          }}
        >
          {tab.name}
        </Link>
      ) : (
        <button
          onClick={() => onClickHandler(tab)}
          type="button"
          disabled={tab.disabled && !tab.active}
          className={`${baseClasses} ${cursorClass} ${getTabClasses()}`}
        >
          {tab.name}
        </button>
      )}
    </>
  );
};
